import { render, staticRenderFns } from "./InputUserStaff.vue?vue&type=template&id=0ff36ee4&"
import script from "./InputUserStaff.vue?vue&type=script&lang=js&"
export * from "./InputUserStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports